import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import { SET_LOCATION_NAME_FR, SET_LOCATION_NAME_ERROR } from "actions/types";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name } = this.props;

		let success = true;

		if (!name) {
			dispatch({
				type: SET_LOCATION_NAME_ERROR
			});
			success = false;
		}

		return success;
	}

	render() {
		const { dispatch, nameErrorMsg, name } = this.props;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name-fr"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_LOCATION_NAME_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { name, nameErrorMsg } = state.locationReducer;

	return {
		name,
		nameErrorMsg
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step1
);
